import { getReq, postRed } from './axiosFun'

export const monthlyStats = (year) => {
  return getReq('get', '/sp/admin/stats/monthly', { year: year })
}

export const dailyStats = (year, month) => {
  return getReq('get', '/sp/admin/stats/daily', { year: year, month: month })
}

export const rentPage = (params) => {
  return getReq('get', '/sp/admin/rent/page', params)
}

export const salePage = (params) => {
  return getReq('get', '/sp/admin/sale/page', params)
}

export const auditRent = (id, auditStatus) => {
  return postRed('post', '/sp/admin/rent/audit', { id: id, auditStatus: auditStatus })
}

export const auditSale = (id, auditStatus) => {
  return postRed('post', '/sp/admin/sale/audit', { id: id, auditStatus: auditStatus })
}

export const buyIntentPage = (params) => {
  return getReq('get', '/sp/admin/intent/buy/page', params)
}

export const updateBuyIntentStatus = (id, status) => {
  return postRed('post', '/sp/admin/intent/buy/status', { id: id, status: status })
}

export const visitPage = (params) => {
  return getReq('get', '/sp/admin/visit/page', params)
}

export const sellIntentPage = (params) => {
  return getReq('get', '/sp/admin/intent/sell/page', params)
}

export const forumPage = (params) => {
  return getReq('get', '/sp/admin/forum/page', params)
}

export const forumDetail = (id) => {
  return getReq('get', '/sp/admin/forum/detail', { id: id })
}

export const auditForum = (id, auditStatus) => {
  return postRed('post', '/sp/admin/forum/audit', { id: id, auditStatus: auditStatus })
}

export const deleteForumComment = (id) => {
  return getReq('get', '/sp/admin/forum/comment/delete', { id: id })
}

export const rentDetail = (id) => {
  return getReq('get', '/sp/admin/rent/detail', { id: id })
}

export const saveRent = (data) => {
  return postRed('post', '/sp/admin/rent/save', data)
}

export const saleDetail = (id) => {
  return getReq('get', '/sp/admin/sale/detail', { id: id })
}

export const saveSale = (data) => {
  return postRed('post', '/sp/admin/sale/save', data)
}

export const offlineRent = (id) => {
  return getReq('get', '/sp/admin/rent/offline', { id: id })
}

export const offlineSale = (id) => {
  return getReq('get', '/sp/admin/sale/offline', { id: id })
}

export const deleteForum = (id) => {
  return getReq('get', '/sp/admin/forum/delete', { id: id })
}

export const updateVisitStatus = (id, status) => {
  return postRed('post', '/sp/admin/visit/status', { id: id, status: status })
}

export const updateSellIntentStatus = (id, status) => {
  return postRed('post', '/sp/admin/intent/sell/status', { id: id, status: status })
}

export function pageBody(res) {
  const data = (res && res.data) || {}
  return {
    list: data.list || [],
    total: data.totalRow || 0
  }
}

export const fetchCityNames = () => {
  return getReq('get', '/sp/meta/cities').then(res => {
    const data = (res && res.data) || []
    return Array.isArray(data) ? data : []
  })
}

export const adminCityList = () => {
  return getReq('get', '/sp/admin/city/list')
}

export const saveCity = (data) => {
  return postRed('post', '/sp/admin/city/save', data)
}

export const deleteCity = (id) => {
  return getReq('get', '/sp/admin/city/delete', { id: id })
}



// WEBPACK FOOTER //
// ./src/api/spAdmin.js